export default function ArrowLeftIcon() {
  return (
    <svg width="2.2rem" height="2.2rem" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.0833 6.41699L5.5 11.0003L10.0833 15.5837" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M5.5 11H16.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  )
}
